import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-location';

const HomePage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    console.info('There is no base route on this app. Navigating to /sign-in');
    navigate({ to: '/sign-in', replace: true });
  }, []);
  //return <ContentLoader message='Redirecting' show />; Don't show the content loader, it doesn't help, and feels more choppy.
  return null;
};

export default HomePage;
